import ChannelList from '../../lists/channel-list';
import Heading from '../../typography/v2/heading';
import Container from '../container';

type ChannelsQuery = 'GROUP' | 'DIRECT';

type Props = {
  query: ChannelsQuery;
  title: string;
};

export default function ChannelSection({ title, query }: Props) {
  return (
    <section className="w-full mb-2">
      <Container extensions="px-2 py-3 bg-black z-30 border-y border-l border-dark-gray w-full">
        <Heading variant="secondary">{title}</Heading>
      </Container>
      <ChannelList query={query} />
    </section>
  );
}
